export default {
  app: {
    title: 'Overpass Planner',
    labs: 'LABS',
  },
  toolbar: {
    layers: 'Layers',
    filters: 'Filters',
    monitoredAreas: 'Monitored Areas',
    settings: 'Settings',
  },
  layers: {
    baseMaps: 'Base Maps',
    cloudLayers: 'Cloud Layers',
    eumetsatTrueRgb: 'EUMETSAT True RGB',
    eumetsatIr: 'EUMETSAT IR 10.8',
    opacity: 'Opacity',
    overlays: 'Overlays',
    satelliteOverpasses: 'Satellite Overpasses',
    aoiCoverage: 'AOI Coverage',
    hexGrid: 'Hex Grid (Next Overpass)',
  },
  filters: {
    title: 'Filters',
    savePreset: 'Save preset',
    deletePreset: 'Delete preset',
    info: 'Info',
    preset: 'Preset',
    cloudCoverForecast: 'Cloud Cover Forecast',
    cloudCoverDescription: 'Hide overpasses with cloud cover forecast above this threshold.',
    satellites: 'Satellites',
    satellitesFilter: 'Filter by satellite',
    satellitesDescription: 'Satellites grouped by sensor type.',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    ororaTechSafire: 'OroraTech SAFIRE',
    showGrouped: 'Show grouped',
    showIndividual: 'Show individual',
    predicted: 'Orbital Path',
    scheduled: 'Scheduled',
    scheduledOnlyNote: 'Scheduled acquisitions are confirmed tasking windows, available for the next 48 hours only. Orbital Path is predicted and covers the full range.',
    retired: 'retired',
    backup: 'backup',
    allSatellites: 'All Satellites',
    customPreset: 'Custom Preset',
    manual: 'Manual',
    selectedOfTotal: '{selected} of {total} selected',
  },
  monitor: {
    title: 'Monitor',
    addArea: 'Add area',
    dropzoneTitle: 'Drag & drop GeoJSON files here',
    dropzoneSubtitle: 'or click to browse',
    dropzoneHint: '.geojson or .json — max 5 MB per file',
    dropFiles: 'Drop to upload',
    noAreasYet: 'No monitored areas yet',
    noAreasDescription: 'Select an AOI from the dropdown above and click {action} to calculate coverage.',
    compute: 'Compute',
    name: 'Name',
    overpasses: 'Overpasses',
    calculated: 'Calculated',
    computing: 'Computing...',
    area: 'Area',
    export: 'Export',
    delete: 'Delete',
    clickToPan: 'Click to pan, double-click to rename',
    selected: '{count} selected',
  },
  list: {
    title: 'Overpass List',
    satellite: 'Satellite',
    direction: 'Direction',
    start: 'Start',
    end: 'End',
    sensor: 'Sensor',
    resolution: 'Resolution',
    light: 'Light',
    cloud: 'Cloud',
    latency: 'Latency',
    delivery: 'Delivery',
    loading: 'Loading satellite data...',
    zoomIn: 'Zoom in to see individual overpasses.',
    noOverpasses: 'No overpasses visible with current filters.',
    uploadAoiToView: 'Upload an area of interest to view overpass data.',
    selectGridCell: 'Select a grid cell on the map to view overpass data.',
    day: 'day',
    night: 'night',
    close: 'Close',
    maxCloudCover: 'Max cloud cover: {value}%',
  },
  popup: {
    start: 'Start',
    end: 'End',
    direction: 'Direction',
    ascending: 'Ascending',
    descending: 'Descending',
    sensor: 'Sensor',
    resolution: 'Resolution',
    constellation: 'Constellation',
    daylight: 'Daylight',
    day: 'Day',
    night: 'Night',
    dayEmoji: '☀ Day',
    nightEmoji: '🌙 Night',
    cloudCoverForecast: 'Cloud cover forecast',
    cloudCoverObserved: 'Cloud cover (observed)',
    notCalculated: 'Not calculated',
    expectedLatency: 'Expected latency',
    expectedDelivery: 'Expected delivery',
    from: 'From',
    to: 'To',
    coverage: '{pct}% Coverage',
    areaCovered: 'Area covered',
  },
  timeline: {
    title: 'Timeline Graph',
    coveragePct: 'Coverage %',
    allSatellites: 'All Satellites',
    bySatellite: 'By Satellite',
    bySensor: 'By Sensor',
    restore: 'Restore',
    maximize: 'Maximize',
    close: 'Close',
    uploadAoiTimeline: 'Upload an area of interest to view the timeline.',
    selectGridTimeline: 'Select a grid cell on the map to view the timeline.',
  },
  hexLegend: {
    title: 'Time to Next Overpass',
    expandLegend: 'Expand legend',
    collapseLegend: 'Collapse legend',
    noOverpasses: 'No overpasses in next {hours} hours',
    notComputed: 'Not computed for this period',
    coveragePast: 'The grid is precomputed forward from the latest build — past overpasses are not available here. Use the swath or AOI view for past dates.',
    coverageOtOnly: 'Beyond {date} the grid covers the OroraTech constellation only.',
    coverageBeyondAll: 'The grid ends at {date}. Nothing is precomputed past that.',
    cellsSelected: '{count} cell(s) selected',
    clear: 'Clear',
  },
  hexTooltip: {
    nextOverpass: 'Next Overpass',
    satellite: 'Satellite',
    acquisition: 'Acquisition time',
    cloudForecast: 'Cloud forecast',
    status: 'Status',
    noOverpass: 'No overpass in selected window',
    timeIn: 'In',
    totalPasses: 'Total passes',
  },
  settings: {
    language: 'Language',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    timezone: 'Timezone',
    local: 'Local',
    colorblindFriendly: 'Colorblind-friendly colors',
  },
  timeControls: {
    start: 'Start',
    end: 'End',
    now: 'Now',
    showGraph: 'Show Graph',
    hideGraph: 'Hide Graph',
    showPanel: 'Show Panel',
    hidePanel: 'Hide Panel',
    setStartToNow: 'Set start to now',
    resetTimeRange: 'Reset time range',
    gridCoverageHint: 'Precomputed: all satellites to {allSatellitesEnd}, OroraTech only to {end}. No past dates.',
  },
  viewToggle: {
    aoi: 'AOI',
    grid: 'Grid',
    swaths: 'Swaths',
    aoiTitle: 'AOI View — Show only AOI coverage',
    gridTitle: 'Grid View — Time to next overpass',
    swathTitle: 'Swath View',
  },
  geocoder: {
    searchPlaceholder: 'Search location…',
    coordinates: 'Coordinates',
    noResults: 'No results for',
    clearSearch: 'Clear search',
    trackGeolocation: 'Track geolocation',
    toggleGeolocation: 'Toggle geolocation',
  },
  aoi: {
    selectOrUpload: 'Select or upload AOI…',
    compute: 'Compute',
    computing: 'Computing…',
    uploadGeoJson: 'Upload AOI GeoJSON',
    aoiLabel: 'AOI',
    clearAoi: 'Clear AOI',
    uploadNew: 'Upload new GeoJSON…',
    computeCoverage: 'Compute Coverage',
  },
  startup: {
    title: 'Get started with an area of interest',
    body: 'Upload an AOI to run coverage calculations, or continue with a global view.',
    dropzoneTitle: 'Drag & drop GeoJSON files here',
    dropzoneSubtitle: 'or click to browse',
    dropzoneHint: '.geojson or .json — max 5 MB per file',
    or: 'or',
    uploadAoi: 'Upload AOI',
    continueGlobal: 'Continue to Global View',
  },
  common: {
    zoomInHint: 'Zoom in to view satellite overpass information',
    openOverpassList: 'Open overpass list',
    cloudCoverForecast: 'Cloud cover forecast',
    groupedConstellation: 'Grouped constellation',
    individualSatellites: 'Individual satellites',
  },
};
